document.addEventListener("DOMContentLoaded", function () {
  const tabWrappers = document.querySelectorAll(".custom-tabs-wrapper");

  tabWrappers.forEach((tabWrapper) => {
    function openTab(tab, depth = 0) {
      if (!tab || depth > 10) return; 

      if (tab.classList.contains("hidden")) {
        const nextTab = tab.nextElementSibling || tabWrapper.querySelector(".tab-item");
        openTab(nextTab, depth + 1);
        return; 
      }

      const target = tab.getAttribute("data-target");
      const description = tabWrapper.querySelector(`#${target}`);

      if (!description) return;

      tabWrapper
        .querySelectorAll(".tab-item-description.visible")
        .forEach((desc) => {
          desc.classList.remove("visible");
        });

      tabWrapper.querySelectorAll(".tab-item.visible").forEach((item) => {
        item.classList.remove("visible");
      });

      description.classList.add("visible");
      tab.classList.add("visible");
    }

    tabWrapper.addEventListener("click", function (event) {
      const tab = event.target.closest(".tab-item");
      if (tab && tabWrapper.contains(tab)) {
        openTab(tab);
      }
    });

    const firstTab = tabWrapper.querySelector(".tab-item");
    if (firstTab) {
      openTab(firstTab);
    }
  });
});